export const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API;
export const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;

export const PUBLIC_URL = process.env.PUBLIC_URL;

export const IN_PROD = process.env.NODE_ENV === 'production';
